<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Cargas Asignadas por Fecha</h4>
    <hr />

    <!-- Instrucciones -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert">
      <strong>Instrucciones:</strong>
      Seleccione un rango rápido o ingrese las fechas manualmente, elija el tipo y presione
      <strong>Consultar</strong>.
    </div>

    <!-- Filtros -->
    <div class="container mb-4">
      <div class="row g-3">
        <!-- Botones de rango rápido -->
        <div class="col-12 d-flex flex-wrap gap-2">
          <button class="btn btn-outline-primary   btn-sm" @click="setToday">Hoy</button>
          <button class="btn btn-outline-danger    btn-sm" @click="setThisWeek">Semana Actual</button>
          <button class="btn btn-outline-secondary btn-sm" @click="setThisMonth">Mes Actual</button>
          <button class="btn btn-outline-success   btn-sm" @click="setThisQuarter">Trimestre Actual</button>
          <button class="btn btn-outline-info      btn-sm" @click="setThisSemester">Semestre Actual</button>
          <button class="btn btn-outline-warning   btn-sm" @click="setThisYear">Año Actual</button>
        </div>

        <!-- Desde -->
        <div class="col-auto">
          <label class="form-label fw-bold">Desde</label>
          <input type="date" class="form-control" v-model="fechaDesde" />
        </div>

        <!-- Hasta -->
        <div class="col-auto">
          <label class="form-label fw-bold">Hasta</label>
          <input type="date" class="form-control" v-model="fechaHasta" />
        </div>

        <!-- Tipo -->
        <div class="col-auto">
          <label class="form-label fw-bold">Tipo</label>
          <select v-model="tipo" class="form-select" style="width:200px">
            <option value="doc">Gestión Documental</option>
            <option value="aud">Auditoría Médica</option>
          </select>
        </div>

        <!-- Acciones -->
        <div class="col-auto d-flex align-items-end gap-2">
          <button class="btn btn-dark" @click="fetchDetalle">
            <i class="material-icons me-1" style="font-size:18px;vertical-align:middle">search</i>
            Consultar
          </button>
          <button
            class="btn btn-outline-success"
            @click="exportToCSV"
            :disabled="cargasDetalle.length === 0"
          >
            <i class="material-icons me-1" style="font-size:18px;vertical-align:middle">download</i>
            Exportar CSV
          </button>
        </div>
      </div>
    </div>

    <!-- Contenido con tabs -->
    <div v-if="cargasDetalle.length > 0 || cargasResumen.length > 0">

      <!-- Nav tabs Bootstrap -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <button
            class="nav-link"
            :class="{ active: showDetalle }"
            @click="showDetalleSection"
            type="button"
          >
            Detalle
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="{ active: showResumen }"
            @click="showResumenSection"
            type="button"
          >
            Resumen
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="{ active: showGrafico }"
            @click="showGraficoSection"
            type="button"
          >
            Gráfico
          </button>
        </li>
      </ul>

      <!-- ── Tab Detalle ── -->
      <div v-if="showDetalle">
        <!-- Selector registros por página -->
        <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
          <label class="form-label mb-0 small fw-bold">Mostrar</label>
          <select
            v-model.number="elementosPorPagina"
            class="form-select form-select-sm"
            style="width:75px"
            @change="aplicarPaginacion(1)"
          >
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <span class="small text-muted">registros</span>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th class="th-sort" @click="ordenarPor('idTramite')">
                  Id. Trámite <span>{{ iconOrden('idTramite') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('fechaDesde')">
                  Fecha Desde <span>{{ iconOrden('fechaDesde') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor('fechaHasta')">
                  Fecha Hasta <span>{{ iconOrden('fechaHasta') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor(tipo === 'aud' ? 'nombreMed' : 'nombreDoc')">
                  {{ tipo === 'aud' ? 'Médico' : 'Gestor Documental' }}
                  <span>{{ iconOrden(tipo === 'aud' ? 'nombreMed' : 'nombreDoc') }}</span>
                </th>
                <th class="th-sort" @click="ordenarPor(tipo === 'aud' ? 'fechaAsigAud' : 'fechaAsigDoc')">
                  F. Asignación
                  <span>{{ iconOrden(tipo === 'aud' ? 'fechaAsigAud' : 'fechaAsigDoc') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarPor('numeroRegistros')">
                  N° Registros <span>{{ iconOrden('numeroRegistros') }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="carga in detallesPaginados" :key="carga.idCarga">
                <td class="text-center">{{ carga.idTramite }}</td>
                <td>{{ getFormattedDate(carga.fechaDesde) }}</td>
                <td>{{ getFormattedDate(carga.fechaHasta) }}</td>
                <td>{{ tipo === 'aud' ? carga.nombreMed : carga.nombreDoc }}</td>
                <td>{{ getFormattedDate(tipo === 'aud' ? carga.fechaAsigAud : carga.fechaAsigDoc) }}</td>
                <td class="text-end">{{ carga.numeroRegistros }}</td>
              </tr>
              <tr v-if="detallesFiltrados.length === 0">
                <td colspan="6" class="text-center text-muted py-3">No hay resultados.</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary">
                <td colspan="6" class="text-end fw-bold small">
                  Mostrando {{ detallesPaginados.length }} de {{ detallesFiltrados.length }} registros
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Paginación -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <span class="small text-muted">
            Página {{ paginaActual }} de {{ totalPaginas() }} —
            {{ detallesFiltrados.length }} registros
          </span>
          <nav aria-label="Paginación">
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
              </li>
              <li class="page-item" :class="{ disabled: paginaActual === 1 }">
                <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
              </li>
              <li
                v-for="pagina in paginasVisibles"
                :key="pagina"
                class="page-item"
                :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>
              <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
                <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
              </li>
              <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
                <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!-- ── Tab Resumen ── -->
      <div v-if="showResumen">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th class="th-sort" @click="ordenarResumenPor('nombre')">
                  {{ tipo === 'aud' ? 'Nombre Médico Auditor' : 'Nombre Gestor Documental' }}
                  <span>{{ iconOrdenResumen('nombre') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarResumenPor('contadorTramites')">
                  Núm. Trámites <span>{{ iconOrdenResumen('contadorTramites') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarResumenPor('contadorCargas')">
                  Núm. Cargas <span>{{ iconOrdenResumen('contadorCargas') }}</span>
                </th>
                <th class="th-sort text-end" @click="ordenarResumenPor('sumaRegistros')">
                  Núm. Atenciones <span>{{ iconOrdenResumen('sumaRegistros') }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="carga in resumenOrdenado" :key="carga.nombre">
                <td>{{ carga.nombre }}</td>
                <td class="text-end">{{ carga.contadorTramites }}</td>
                <td class="text-end">{{ carga.contadorCargas }}</td>
                <td class="text-end">{{ carga.sumaRegistros }}</td>
              </tr>
              <tr v-if="cargasResumen.length === 0">
                <td colspan="4" class="text-center text-muted py-3">No hay resultados.</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="table-secondary">
                <td colspan="4" class="text-end fw-bold small">
                  {{ cargasResumen.length }} registros
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- ── Tab Gráfico ── -->
      <div v-if="showGrafico">
        <div class="alert alert-warning mt-3" role="alert">
          Módulo de gráfico desactivado temporalmente. (vue3-apexcharts no disponible)
        </div>
      </div>

    </div>

    <!-- Sin resultados -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import {
  getToday,
  getThisWeek,
  getThisMonth,
  getThisQuarter,
  getThisSemester,
  getThisYear,
} from "@/modules/queryDateUtils.js";

export default {
  components: { Layout, Footer },
  data() {
    return {
      fechaDesde:         "",
      fechaHasta:         "",
      tipo:               "doc",
      cargasResumen:      [],
      cargasDetalle:      [],
      sinResultados:      false,
      showDetalle:        true,
      showResumen:        false,
      showGrafico:        false,
      idEmpresa:          0,
      // Paginación detalle
      elementosPorPagina: 10,
      detallesPaginados:  [],
      paginaActual:       1,
      // Ordenamiento detalle
      campoOrden:         "idTramite",
      ascendente:         false,
      // Ordenamiento resumen
      campoOrdenResumen:  "nombre",
      ascendenteResumen:  true,
      // Gráfico (sin uso por ahora)
      chartOptions: {
        chart: { toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true } },
        xaxis: { categories: [] },
        yaxis: { title: { text: "Cantidad de Citas" } },
      },
      chartSeries: [{ name: "Citas por Motivo", data: [] }],
    };
  },
  computed: {
    detallesFiltrados() {
      const campo = this.campoOrden;
      return [...this.cargasDetalle].sort((a, b) => {
        let va = a[campo] ?? "";
        let vb = b[campo] ?? "";
        if (campo === "idTramite" || campo === "numeroRegistros") {
          const na = parseFloat(va);
          const nb = parseFloat(vb);
          if (!isNaN(na) && !isNaN(nb))
            return this.ascendente ? na - nb : nb - na;
        }
        if (campo === "fechaDesde" || campo === "fechaHasta" ||
            campo === "fechaAsigAud" || campo === "fechaAsigDoc") {
          const da = new Date(va);
          const db = new Date(vb);
          if (!isNaN(da) && !isNaN(db))
            return this.ascendente ? da - db : db - da;
        }
        const cmp = String(va).localeCompare(String(vb), "es");
        return this.ascendente ? cmp : -cmp;
      });
    },
    resumenOrdenado() {
      const campo = this.campoOrdenResumen;
      return [...this.cargasResumen].sort((a, b) => {
        let va = a[campo] ?? "";
        let vb = b[campo] ?? "";
        if (campo !== "nombre") {
          const na = parseFloat(va);
          const nb = parseFloat(vb);
          if (!isNaN(na) && !isNaN(nb))
            return this.ascendenteResumen ? na - nb : nb - na;
        }
        const cmp = String(va).localeCompare(String(vb), "es");
        return this.ascendenteResumen ? cmp : -cmp;
      });
    },
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (
        let i = Math.max(2, actual - delta);
        i <= Math.min(total - 1, actual + delta);
        i++
      ) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach((p) => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
  watch: {
    tipo() {
      if (this.showResumen) this.fetchResumen();
      if (this.showDetalle) this.fetchDetalle();
    },
  },
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    // ── Ordenamiento detalle ───────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },
    // ── Ordenamiento resumen ───────────────────────────────
    ordenarResumenPor(campo) {
      if (this.campoOrdenResumen === campo) {
        this.ascendenteResumen = !this.ascendenteResumen;
      } else {
        this.campoOrdenResumen = campo;
        this.ascendenteResumen = true;
      }
    },
    iconOrdenResumen(campo) {
      if (this.campoOrdenResumen !== campo) return "⇅";
      return this.ascendenteResumen ? "↑" : "↓";
    },
    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      return Math.max(
        1,
        Math.ceil(this.detallesFiltrados.length / this.elementosPorPagina)
      );
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual     = noPagina;
      const ini             = (noPagina - 1) * this.elementosPorPagina;
      this.detallesPaginados = this.detallesFiltrados.slice(
        ini,
        ini + this.elementosPorPagina
      );
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas())
        this.aplicarPaginacion(this.paginaActual + 1);
    },
    // ── Fetch ──────────────────────────────────────────────
    fetchDetalle() {
      if (!this.fechaDesde || !this.fechaHasta) return;
      this.sinResultados = false;
      api
        .get(`/vwcargaext/asignadas-detalle`, {
          params: {
            idEmpresa:  this.idEmpresa,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            tipo:       this.tipo,
          },
        })
        .then((response) => {
          this.cargasDetalle = Array.isArray(response.data) ? response.data : [];
          this.sinResultados = this.cargasDetalle.length === 0;
          this.aplicarPaginacion(1);
        })
        .catch((error) => {
          console.error("Error fetching detalle:", error);
          this.sinResultados = true;
        });
    },
    fetchResumen() {
      if (!this.fechaDesde || !this.fechaHasta) return;
      api
        .get(`/vwcargaext/asignadas-resumen`, {
          params: {
            idEmpresa:  this.idEmpresa,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            tipo:       this.tipo,
          },
        })
        .then((response) => {
          this.cargasResumen = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => console.error("Error fetching resumen:", error));
    },
    fetchGrafico() {
      api
        .get(`/vwcargaext/asignadas-resumen`, {
          params: {
            idEmpresa:  this.idEmpresa,
            fechaDesde: this.fechaDesde,
            fechaHasta: this.fechaHasta,
            tipo:       this.tipo,
          },
        })
        .then((response) => {
          const datos = response.data || [];
          this.chartOptions.xaxis.categories = datos.length
            ? datos.map((i) => i.nombre || "Sin Datos")
            : ["Sin Datos"];
          this.chartSeries[0].data = datos.length
            ? datos.map((i) => i.sumaRegistros || 0)
            : [0];
        })
        .catch((error) => {
          console.error("Error fetching gráfico:", error);
          this.chartOptions.xaxis.categories = ["Sin Datos"];
          this.chartSeries[0].data = [0];
        });
    },
    // ── Tabs ──────────────────────────────────────────────
    showDetalleSection() {
      this.showDetalle = true;
      this.showResumen = false;
      this.showGrafico = false;
      this.fetchDetalle();
    },
    showResumenSection() {
      this.showDetalle = false;
      this.showResumen = true;
      this.showGrafico = false;
      this.fetchResumen();
    },
    showGraficoSection() {
      this.showDetalle = false;
      this.showResumen = false;
      this.showGrafico = true;
    },
    // ── Rangos rápidos ─────────────────────────────────────
    setDateRange(fn) {
      const dates     = fn();
      this.fechaDesde = dates.fechaDesde;
      this.fechaHasta = dates.fechaHasta;
      this.fetchDetalle();
    },
    setToday()        { this.setDateRange(getToday);        },
    setThisWeek()     { this.setDateRange(getThisWeek);     },
    setThisMonth()    { this.setDateRange(getThisMonth);    },
    setThisQuarter()  { this.setDateRange(getThisQuarter);  },
    setThisSemester() { this.setDateRange(getThisSemester); },
    setThisYear()     { this.setDateRange(getThisYear);     },
    // ── Helpers ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // ── Exportar CSV (separador ";") ───────────────────────
    exportToCSV() {
      const escape = (val) => {
        if (val === null || val === undefined) return "";
        const str = String(val).replace(/"/g, '""');
        return str.includes(";") || str.includes("\n") ? `"${str}"` : str;
      };
      const nombreCol = this.tipo === "aud" ? "Médico" : "Gestor Documental";
      const fechaCol  = this.tipo === "aud" ? "F. Asig. Auditoría" : "F. Asig. Documental";
      const headers   = [
        "Id. Trámite", "Fecha Desde", "Fecha Hasta",
        nombreCol, fechaCol, "N° Registros",
      ];
      const rows = [
        headers.join(";"),
        ...this.cargasDetalle.map((c) =>
          [
            c.idTramite,
            this.getFormattedDate(c.fechaDesde),
            this.getFormattedDate(c.fechaHasta),
            this.tipo === "aud" ? c.nombreMed : c.nombreDoc,
            this.getFormattedDate(this.tipo === "aud" ? c.fechaAsigAud : c.fechaAsigDoc),
            c.numeroRegistros,
          ]
            .map(escape)
            .join(";")
        ),
      ];
      const bom  = "\uFEFF";
      const blob = new Blob([bom + rows.join("\n")], { type: "text/csv;charset=utf-8;" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = `cargas_${this.tipo}_${this.fechaDesde}_${this.fechaHasta}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
</style>